export default "__VITE_ASSET__LYzhk6JM__"